import sideMenuStyle from './SideMenu.module.scss';
import foxbelMusic from "../../../assets/images/musicaklive.png";
import React from 'react';
const { useEffect, useState } = React;

type SideMenuProps = {
    className?: any,
    sections: Array<{
        title: string,
        links: { name: string, link: string, selected?: true | false }[]
    }>
}

export const SideMenu = ({ className = "", sections = [] }: SideMenuProps) => {
    const [selected, setSelected] = useState("");

    useEffect(() => {
        setSelected(window.location.hash);
    }, [])

    const changeMenu = (section: string) => {
        setSelected(section);
    }

    return (
        <div className={`${sideMenuStyle.sideMenu} ${className}`}>
            <div className={sideMenuStyle.logo}>
                <img src={foxbelMusic} alt="foxbel-Logo" />
            </div>
            <div className={sideMenuStyle.list}>
                {sections.map((section, idx) => (
                    <div key={section.title + idx} className={sideMenuStyle.section}>
                        <h4>{section.title}</h4>
                        <ul>
                            {section.links.map((link, idx) => {
                                return (
                                    <li
                                        key={link.name + idx}
                                        className={selected === link.link ? sideMenuStyle.selected : ""}>
                                        <a onClick={() => changeMenu(link.link)} href={link.link}>{link.name}</a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    )
}